export default __webpack_public_path__ + "static/media/_DSC0504-thumb.9c981575.jpg";